// extracted by css-extract-rspack-plugin
var _1 = "n19HDUPvquGJJ-8SKzlV2g--";
var _2 = "dg3HbZ5dIpY0JU5OfZSYig--";
var _3 = "xa1c-hUleMsqo0tci2rkhg--";
export { _1 as "inputWrapper", _2 as "label", _3 as "resultItem" }
